import { render, staticRenderFns } from "./PunishmentLength.vue?vue&type=template&id=1873b35d&scoped=true&"
import script from "./PunishmentLength.vue?vue&type=script&lang=ts&"
export * from "./PunishmentLength.vue?vue&type=script&lang=ts&"
import style0 from "./PunishmentLength.vue?vue&type=style&index=0&id=1873b35d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1873b35d",
  null
  
)

export default component.exports